<template>
    <div class="login" id="login">
        <h2>登录</h2>
        <div class="login-form">
            <mt-field label="用户名" placeholder="请输入用户名" v-model="username"></mt-field>
            <mt-field label="密码" placeholder="请输入密码" type="password" v-model="password"></mt-field>
            <div class="new-form-button">
                <mt-button size="large" type="primary" @click="login()">登录</mt-button>
            </div>
        </div>
    </div>
</template>
<style>
    .login{
        padding:40px 25px;
    }
    .login h2{
        padding:20px 20px  20px 10px;
    }
</style>
<script>
    export default {
        data(){
            return {
                username:'',
                password:'',
            //    openid:'oh_QtwdMN2NBKkGDyQUXXbdWTA7I'
                openid:''
            }
        },

        created(){
            this.$axios.post("/oauth", {code: this.$route.query.code})
                .then(data => {

                    if (data.data.code === 'OK') {
                        this.openid = data.data.data;
                    } else {
                        this.$toast(data.data.message);
                    }
                });
        },

        methods:{
            login(){

                if(this.openid===''){
                    return false;
                }

                if(this.username===''||this.password===''){
                    this.$toast({
                        message: '请输入用户名或密码',
                        position: 'top',
                        duration: 5000
                    });
                    return false;
                }else{
                    this.$indicator.open('登录中');

                    this.$axios.post("/login", {username:this.username,password:this.password,openid:this.openid})
                        .then(data => {

                            this.$indicator.close();

                            if (data.data.code === 'OK') {
                                this.$toast(data.data.message);
                                localStorage.setItem("UserInfo", JSON.stringify(data.data.data));
                                this.$router.push("/");
                            } else {
                                this.$toast(data.data.message);
                            }
                        });
                }

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/login.vue